// NOTE: these are providers ids in simply book
//       if some user stop to work with us - we remove his/her id from this list
export const PROVIDERS = '2,3,5,6,7,8,9,10'

export const VALIDATION_MESSAGES = {
  required: '{fieldName} is a required field'
}

export enum Level {
  LevelRbt = 'LEVEL_RBT',
  LevelBcba = 'LEVEL_BCBA',
  LevelBtToRbt = 'LEVEL_BT_TO_RBT'
}

const LEVEL_NAMES: Record<Level, string> = {
  [Level.LevelRbt]: "I'm a credentialed RBT",
  [Level.LevelBcba]: "I'm a credentialed BCBA",
  [Level.LevelBtToRbt]: "I'm a BT looking to become a RBT"
}

export const LEVEL_OPTIONS = Object.values(Level).map(key => ({
  value: key,
  label: LEVEL_NAMES[key]
}))

export const ROUTES = {
  homePage: '/',
  abaTherapy: '/services/aba-therapy',
  autismDiagnosis: '/services/autism-diagnosis',
  locations: '/locations',
  selectedState: '/locations/states/:state',
  selectedCity: '/locations/cities/:city',
  ourClinicians: '/team',
  learningStudio: '/studio',
  learningStudioCategory: '/studio/:category',
  learningStudioArticle: '/studio/:category/:article',
  faq: '/faq',
  joinUs: '/join-us',
  corporateCareers: '/corporate-careers',
  forPediatricians: '/for-physicians',
  openRoles: '/open-roles',
  ourStory: '/our-story',
  contactUs: '/contact',
  abaCostCalculator: '/aba-cost-calculator',
  booking: '/parent-booking',
  terms: '/terms',
  policy: '/policy',
  nonDiscrimination: '/notice-of-non-discrimination',
  privacyPractices: '/privacy-practices',
  sitemap: '/sitemap.xml',
  page404: 'page404'
}

export const OLD_BLOG_ENTRIES = [
  '/aba-therapy*',
  '/autism-treatment*',
  '/autism*',
  '/autism-causes*',
  '/autism-diagnosis*',
  '/aba-terms*',
  '/speech-therapy*',
  '/aba-therapists*',
  '/behavior-analysts*',
  '/rbt*',
  '/autism-therapy*',
  '/autism-and-education*',
  '/autism-resources*',
  '/occupational-therapy*',
  '/types-of-autism*',
  '/autism-family-guide*',
  '/autism-and-diet*',
  '/autism-symptoms*',
  '/mood-disorders*',
  '/aspergers*',
  '/guide*',
  '/guides*',
  '/preventive*',
  '/career*'
]

export const TRANSLATIONS = {
  apiErrors: {},
  genericError: 'Something went wrong. Please reload app and try again',
  // CRITICAL! Do not change this number, as CallTrackingMetrics script relies on it.
  // Contact marketing team to confirm the changes of the CTM before changing!
  genericPhoneNum: '(833) 458-0386'
}

export const MARKETING_ATTRIBUTION_COOKIE_EXPIRATION_TIME = 90 * 24 * 60 * 60 * 1000 // 90 days
export const LANDING_PAGE_COOKIE = 'landing_page_url'
export const FIRST_TOUCH_URL_COOKIE = 'first_touch_url'
export const MARKETING_ATTRIBUTION_COOKIE = 'marketing_attribution'
export const CURRENT_BOOKING_FLOW_STEP = 'booking_flow_step'
export const SESSION_ID_COOKIE = 'user_session_id'
export const SESSION_ID_COOKIE_EXPIRATION_TIME = 7 * 24 * 60 * 60 * 1000 // 7 days

export enum LeadSources {
  Facebook = 'Facebook',
  FacebookPaid = 'Facebook Paid',
  GoogleAds = 'Google Ads',
  GoogleOrganic = 'Google Organic',
  GoogleMyBusiness = 'Google My Business', // LEAD_SOURCE_GOOGLE_MAPS
  YextPartners = 'Yext Partners', // LEAD_SOURCE_GOOGLE_MAPS
  GoogleMaps = 'Google Maps', // LEAD_SOURCE_GOOGLE_MAPS
  BingOrganic = 'Bing Organic',
  Direct = 'Direct',
  Other = 'Other'
}

export enum ProviderBackendErrorMessage {
  InvalidEmail = 'Invalid Email',
  InvalidPassword = 'Invalid Password',
  EmailAlreadyExists = 'Email already exists',
  TokenExpired = 'Token Expired',
  TokenInvalid = 'Token Invalid',
  ActionForbidden = 'Action forbidden',
  InternalError = 'Internal error',
  InvalidArguments = 'Invalid arguments'
}

export const PROVIDER_UI_ERROR_MESSAGE = {
  [ProviderBackendErrorMessage.InvalidEmail]: "Sorry! This email isn't in our system. Please sign up.",
  [ProviderBackendErrorMessage.InvalidPassword]: 'Sorry! That password is incorrect. Please try again.',
  [ProviderBackendErrorMessage.EmailAlreadyExists]:
    'Our records show this email is already registered. Please sign in via the link sent to your email',
  [ProviderBackendErrorMessage.TokenExpired]:
    'Sorry! There was an error on our end. Please reach out to recruiting@elemy.com',
  [ProviderBackendErrorMessage.TokenInvalid]:
    'Sorry! There was an error on our end. Please reach out to recruiting@elemy.com',
  [ProviderBackendErrorMessage.ActionForbidden]:
    'Sorry! There was an error on our end. Please reach out to recruiting@elemy.com',
  [ProviderBackendErrorMessage.InternalError]:
    'Sorry! There was an error on our end. Please reach out to recruiting@elemy.com',
  [ProviderBackendErrorMessage.InvalidArguments]: 'Please check the formatting of your response and try again.'
}
